/*
 * Accessibility fix — make scrollable regions keyboard-focusable.
 * WCAG 2.1.1 (A) / ace-nav-scroll-focusable: any element a user can
 * scroll must be reachable with the keyboard.
 *
 * Cause on neauwater.com: GemPages renders product-page <section> blocks
 * with overflow:auto and content that overflows, so they scroll — but they
 * have no tabindex, so a keyboard-only user can't reach them. (The Dawn
 * announcement bar was already fixed directly in announcement-bar.liquid.)
 *
 * Fix: find elements that actually scroll (overflow auto/scroll AND content
 * larger than the box) and are not already focusable, then add tabindex="0".
 * Only true scroll containers are touched, so the tab order isn't polluted.
 */
(function () {
  function isScrollable(el) {
    var cs = getComputedStyle(el);
    var oy = cs.overflowY, ox = cs.overflowX;
    var v = (oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight + 1;
    var h = (ox === 'auto' || ox === 'scroll') && el.scrollWidth > el.clientWidth + 1;
    return v || h;
  }

  function isFocusable(el) {
    if (['A', 'BUTTON', 'INPUT', 'SELECT', 'TEXTAREA'].indexOf(el.tagName) !== -1) return true;
    var ti = el.getAttribute('tabindex');
    return ti !== null && parseInt(ti, 10) >= 0;
  }

  function fixScrollFocus() {
    var nodes = document.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (isScrollable(el) && !isFocusable(el)) {
        el.setAttribute('tabindex', '0');
      }
    }
  }

  function run() {
    fixScrollFocus();
    setTimeout(fixScrollFocus, 800);  // GemPages renders asynchronously
    setTimeout(fixScrollFocus, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
})();
